<mat-card class="mat-elevation-z2 biowetter-card">
  <mat-card-header>
    <mat-card-title>{{biowetter.zoneName}}</mat-card-title>
    <mat-card-subtitle>
      <div>Quelle: {{biowetter.provider}}</div>
      <div>Aktualisiert: {{(biowetter.lastUpdate?.toDate() | date : 'dd.MM.yyyy HH:mm') || '?'}}</div>
      <div>Nächste Aktualisierung: {{(biowetter.nextUpdate?.toDate() | date : 'dd.MM.yyyy HH:mm') || '?'}}</div>
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-actions>
    <button mat-button
            *ngFor="let vorhersage of biowetter.vorhersagen; let index = index"
            [class.selected]="selectedIndex === index"
            (click)="updateSelectedVorhersage(index)">
      {{vorhersage.forecastDay | date}} - {{vorhersage.partOfDay}}
    </button>
  </mat-card-actions>
  <mat-card-content>
    <app-biowetter-vorhersage
      *ngIf="hasVorhersageSelected()"
      [vorhersage]="getSelectedVorhersage()">
    </app-biowetter-vorhersage>
  </mat-card-content>
</mat-card>
